import React, { Component } from 'react';
import { Watermark as OriginWatermark } from 'antd';

export default class Watermark extends Component {
    render() {
        return <OriginWatermark {...this.props} />;
    }
}
